// React i hooks
import { memo, useCallback, useState } from "react";

// API servisi i konstante
import { ContactSearchFormValues, ContactType } from "services/api/contacts/types";
import { initialContactSearchForm, initialContactTypes } from "services/api/contacts/consts";


// Tipovi
import { ContactSearchFilterProps } from "./types";

// UI komponente
import { TextField } from "ui/components/TextField/TextField";

// Lokalne komponente
import ContactImportCard from "../../../components/ContactImportCard/ContactImportCard";
import ContactExportCard from "../../../components/ContactExportCard/ContactExportCard";
import { useTranslate } from "helpers";
import { DropdownOption } from "ui/components/Dropdown/Dropdown/types";
import { Dropdown } from "ui/components/Dropdown/Dropdown";

const ContactSearchFilters: React.FC<ContactSearchFilterProps> = (props) => {
  const { onAddNew, onSearchChange } = props;

  const { t } = useTranslate();

  const [formValues, setFormValues] = useState<ContactSearchFormValues>(
    initialContactSearchForm
  );

  const [contactTypes, setContactTypes] =
    useState<ContactType[]>(initialContactTypes);

  const [showImportModal, setShowImportModal] = useState<boolean>(false);
  const [showExportModal, setShowExportModal] = useState<boolean>(false);

  const handleSearchChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    const updatedFormValues = { ...formValues, [name]: value };
    setFormValues(updatedFormValues);
    onSearchChange(updatedFormValues);
  };

  const handleResetFormClick = useCallback(() => {
    setFormValues(initialContactSearchForm);
  }, []);

  const handleDropdownChange = useCallback(
    (_e: any, name: string, item: DropdownOption) => {
      const updatedFormValues = { ...formValues, [name]: item.value };
      setFormValues(updatedFormValues);
      onSearchChange(updatedFormValues);
    },
    [formValues, onSearchChange]
  );


  const contactTypeItems: DropdownOption[] = contactTypes.map((i) => {
    return {
      value: i.id.toString(),
      text: i.name,
    };
  });


  return (
    <>
      <div className=" ">
        <div className="flex justify-between items-center gap-3">
          <div className="flex flex-wrap gap-3">
            <div className="min-w-[200px]">
              <TextField
                type="text"
                name="search"
                value={formValues.search}
                onChange={handleSearchChange}
                placeholder={t("admin.search")}
                startIcon="../media/icons/search.svg"
                cssClassName="bg-white"
              />
            </div>
            <div className="min-w-[200px]">
              <Dropdown
                name="contactTypeId"
                placeholder={t("admin.contact.search.filter.contacttype")}
                options={contactTypeItems}
                onChange={handleDropdownChange}
                value={formValues.contactTypeId}
                cssClassName="bg-white"
              />
            </div>
            <div className="min-w-[200px]">
              <TextField
                type="text"
                name="email"
                value={formValues.email}
                onChange={handleSearchChange}
                placeholder={t("admin.contact.search.filter.email")}
                endIcon="media/icons/email.svg"
                cssClassName="bg-white"
              />
            </div>
            <div className="min-w-[200px]">
              <TextField
                type="text"
                name="phone"
                value={formValues.phone}
                onChange={handleSearchChange}
                placeholder={t("admin.contact.search.filter.phone")}
                endIcon="media/icons/phone.svg"
                cssClassName="bg-white"
              />
            </div>
            <div className="min-w-[200px]">
              <TextField
                type="text"
                name="address"
                value={formValues.address}
                onChange={handleSearchChange}
                placeholder={t("admin.contact.search.filter.address")}
                endIcon="media/icons/map.svg"
                cssClassName="bg-white"
              />
            </div>
            <div className="flex items-center">
              <span
                onClick={handleResetFormClick}
                className="text-xs font-bold cursor-pointer text-gray-700"
              >
                RESET
              </span>
            </div>
          </div>

        </div>
      </div>
      <ContactImportCard
        show={showImportModal}
        onClose={() => setShowImportModal(false)}
      />
      <ContactExportCard
        show={showExportModal}
        onClose={() => setShowExportModal(false)}
      />
    </>
  );
};
export default memo(ContactSearchFilters);
